import styled from "styled-components";

const ContactStyled = styled.section`
  margin-top: 50px;
  margin-bottom: 50px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-top: 200px;
  }
  .contact_container {
    background-color: #f5f5f5;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 30px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
    }

    .contact_info {
      background-color: ${({ theme }) => theme.color.blue};
      padding: 20px;
      height: 380px;

      h2 {
        margin-top: 10px;
        margin-bottom: 15px;
        padding: 0 30px;
        color: white;
      }
      li {
        display: table;
        list-style: none;
        margin-bottom: 20px;
        font-size: 18px;
        color: white;
        padding: 0 30px;
      }
      i {
        margin-right: 20px;
      }
      span {
        display: table-cell;
        font-weight: 200;
      }
    }
  }
  iframe {
    width: 60%;
    height: 350px;
    border: 0;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 100%;
    }
  }
`;

export default ContactStyled;
